import type { AxiosError, AxiosRequestConfig } from 'axios';
import { LOCALE, STORE_ID } from '@/js/api/const.ts';
import axios from 'axios';

type RequestResult<T, E> =
  | { data: T, error: null }
  | { data: null, error: E };

export async function makeRequest<T, E = unknown>(
  config: AxiosRequestConfig,
): Promise<RequestResult<T, E>> {
  try {
    const { data } = await axios<T>(config);
    return { data, error: null };
  }
  catch (err) {
    const axiosError = err as AxiosError<E>;
    return {
      data: null,
      error: axiosError.response?.data ?? (axiosError as unknown as E),
    };
  }
}

export function makeLocalizedStoreApiRoute(url: string) {
  return makeApiRoute(`${STORE_ID}/${LOCALE}/${url}`);
}

export function makeApiRoute(url: string) {
  return `/api/${url}`;
}

export function makeStoreApiRoute(url: string) {
  return makeApiRoute(`${STORE_ID}/${url}`);
}
